<template>
  <router-view/>
</template>

<script>
export default {
  name: 'Inner'
}
</script>
